import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Success from "@/pages/Success";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import MedicalDisclaimer from "@/pages/legal/MedicalDisclaimer";
import CookieConsent from "@/components/CookieConsent";
import AnalyticsRouter from "@/components/AnalyticsRouter";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-ng-bg text-white min-h-screen font-body">
      <BrowserRouter>
        <AnalyticsRouter />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/success" element={<Success />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0B121F",
            color: "#fff",
            border: "1px solid rgba(30,144,255,0.45)",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
